import { Badge, Card, Group } from "@mantine/core";
import React from "react";
import { JobListing } from "@lib/types/jobTypes";
import getRelativeDateString from "@lib/utils/date/relativeDateText";
import SectionHeading from "../Various/SectionHeading";
import SalaryAtAGlace from "./SalaryAtAGlace";
import { useTranslation } from "next-i18next";

function AtAGlace({ job }: { job: JobListing }) {
  const { t } = useTranslation("joblisting");
  return (
    <Card.Section className="p-2">
      <SectionHeading>{t("atAGlance.title")}</SectionHeading>
      <Group spacing={7} mt={5}>
        {job.published_at && (
          <Badge leftSection="📅" size="lg" color="blue">
            {t("atAGlance.activeSince")}{" "}
            {new Date(job.published_at).toLocaleDateString("de-DE")},{" "}
            {getRelativeDateString(new Date(job.published_at))}
          </Badge>
        )}
        {job.application_end && (
          <Badge leftSection="📬" size="lg" color="green">
            {t("atAGlance.applicationEnd")}{" "}
            {new Date(job.application_end).toLocaleDateString("de-DE")},{" "}
            {getRelativeDateString(new Date(job.application_end))}
          </Badge>
        )}
        {job.job_type?.title_translations?.de && (
          <Badge leftSection="⌚" size="lg" color="grape">
            {job.job_type?.title_translations?.de}
          </Badge>
        )}
        {job.job_category?.title_translations?.de && (
          <Badge leftSection="🔨" size="lg" color="teal">
            {job.job_category?.title_translations?.de}
          </Badge>
        )}
        {job.job_industry?.title_translations?.de && (
          <Badge leftSection="🏭" size="lg" color="violet">
            {job.job_industry?.title_translations?.de}
          </Badge>
        )}
        {job.job_employment_type?.title_translations?.de && (
          <Badge leftSection="📝" size="lg" color="blue">
            {job.job_employment_type?.title_translations?.de}
          </Badge>
        )}
        {job.job_location?.title_translations?.de && (
          <Badge leftSection="🪑" size="lg" color="green">
            {job.job_location?.title_translations?.de}
          </Badge>
        )}
        {job.job_address && (
          <Badge leftSection="🗺" size="lg">
            {job.job_address?.address_line_1}, {job.job_address?.zip_code}{" "}
            {job.job_address?.city}
          </Badge>
        )}
        <SalaryAtAGlace salary={job.job_salary} />
      </Group>
    </Card.Section>
  );
}

export default AtAGlace;
